import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentVersionPreview {
    id: string;
    directoryItemId: string;
    code: string;
    content: string;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    errorMessage: string;
}

export class DocumentVersionPreview implements IDocumentVersionPreview {
    id: string;
    directoryItemId: string;
    code: string;
    content: string;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    errorMessage: string;

    constructor();
    constructor(obj: IDocumentVersionPreview);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.directoryItemId = obj && obj.directoryItemId || "";
        this.code = obj && obj.code || "";
        this.content = obj && obj.content || "";
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.errorMessage = obj && obj.errorMessage || "";
    }
}
